import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useEffect, useState } from 'react';
import LessonCardList from './LessonCardList';
import { ILesson } from 'interface/lesson';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles } from '@material-ui/core';
import { IModule } from 'interface/course';

interface IProps {
  title: string;
  module: IModule;
  lessons: Array<any>;
  curLesson: ILesson;
  index: number;
}

const useStyles = makeStyles((theme) => ({
  expasionPanel: {
    color: theme.palette.common.white,
    background: theme.palette.safevideo.dark,
  },
  details: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey['500'],
    color: theme.palette.common.white,
  },
  expasionIcon: {
    '& > span > svg': {
      width: 24,
      height: 'auto',
      fill: theme.palette.grey['100'],
    },
  },
  titleModule: {
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
}));

const ModuleCard = (props: IProps) => {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (props.curLesson.module_id === props.module.id) {
      setIsExpanded(true);
    }
  }, [props.curLesson.module_id, props.module.id]);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Accordion expanded={isExpanded} onChange={handleExpand}>
      <AccordionSummary
        classes={{ root: classes.expasionPanel, expandIcon: classes.expasionIcon }}
        expandIcon={<ExpandMoreIcon />}
        id={`module-${props.module.id}`}
      >
        <span className={classes.titleModule}>{props.title}</span>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <LessonCardList moduleIndex={props.index} selectedLesson={props.curLesson.id} lessons={props.lessons || []} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ModuleCard;
